export default __webpack_public_path__ + "static/media/03-large.302e9eee.jpg";